import React from 'react';
import AdminLayout from '../../components/admin/AdminLayout';
import ContentManager from '../../components/admin/ContentManager';

export default function NewsPage() {
  return (
    <AdminLayout>
      <ContentManager
        title="News & Events Management"
        subtitle="Manage news articles and events"
        contentType="news_events"
        fields={[
          // Basic Information
          { name: 'title', label: 'News & Events Name/Title', type: 'text', required: true },
          { name: 'category', label: 'Category', type: 'select', options: ['News', 'Event', 'Workshop', 'Seminar', 'Training', 'Achievement', 'Award'] },
          { name: 'excerpt', label: 'Short Excerpt/Summary', type: 'textarea', placeholder: 'Brief description for cards (displayed in listings)' },
          { name: 'content', label: 'Full Details/Content', type: 'richtext', hint: 'Complete news/event details with formatting' },

          // Dates
          { name: 'event_date', label: 'News/Events Date', type: 'date', required: true },
          { name: 'start_date', label: 'Start Date (for events)', type: 'date' },
          { name: 'end_date', label: 'End Date (for events)', type: 'date' },

          // Location Fields
          { name: 'event_type', label: 'Event Type', type: 'select', options: ['In-Person', 'Virtual', 'Hybrid'], defaultValue: 'In-Person' },
          { name: 'location', label: 'Event Location (Venue Name)', type: 'text', placeholder: 'e.g., Main Auditorium, ICAR-CISH' },
          { name: 'address', label: 'Full Address', type: 'textarea', placeholder: 'Complete venue address' },
          { name: 'city', label: 'City', type: 'text', placeholder: 'e.g., Lucknow' },
          { name: 'state', label: 'State', type: 'text', placeholder: 'e.g., Uttar Pradesh' },
          { name: 'google_maps_link', label: 'Google Maps Link', type: 'text', placeholder: 'https://maps.google.com/...' },
          { name: 'virtual_event_link', label: 'Virtual Event Link (Zoom/Meet)', type: 'text', placeholder: 'https://zoom.us/...' },

          // Images - File Upload
          { name: 'image_file', label: 'Event Card Thumbnail', type: 'file', fileType: 'image', hint: 'Small image for card display' },
          { name: 'image_url', label: 'Or Thumbnail URL', type: 'text', placeholder: 'External image link' },

          { name: 'banner_file', label: 'Banner Image (Main)', type: 'file', fileType: 'image', hint: 'Single large image for the header' },
          { name: 'banner_image_url', label: 'Or Banner Image URL', type: 'text', placeholder: 'External banner link' },

          { name: 'gallery_images', label: 'Event Gallery (Multiple Images)', type: 'file', multiple: true, fileType: 'image', hint: 'Upload multiple images for the event gallery' },
          { name: 'gallery_images_urls', label: 'Manual Gallery URLs (One per line)', type: 'textarea', placeholder: '/uploads/news/gallery/image1.jpg\n/uploads/news/gallery/image2.jpg', hint: 'Add URLs manually if upload fails. These will be merged with uploaded files.' },

          // Links
          { name: 'link', label: 'Read More Link', type: 'text', placeholder: 'External link for more details' },

          // Display Settings
          { name: 'is_featured', label: 'Featured', type: 'checkbox', defaultValue: false, checkboxLabel: 'Show first in listings' },
          { name: 'is_active', label: 'Active', type: 'checkbox', defaultValue: true, checkboxLabel: 'Item is active' },
          { name: 'is_published', label: 'Published', type: 'checkbox', defaultValue: true, checkboxLabel: 'Visible to public' },
        ]}
        columns={['title', 'category', 'event_date', 'is_featured', 'is_published']}
      />
    </AdminLayout>
  );
}
